module.exports = __webpack_public_path__ + "img/strengthscrm-image3.89648408.svg";